import './Switch.scss';

export default function Switch({
    checked,
    onChange,
    label,
    disabled = false,
    id,
}) {
    const inputId = id || undefined;

    return (
        <label className={`ui-switch${disabled ? ' ui-switch--disabled' : ''}`}>
            <input
                id={inputId}
                className="ui-switch__input"
                type="checkbox"
                role="switch"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange?.(e.target.checked)}
            />
            <span className="ui-switch__track" aria-hidden="true">
                <span className="ui-switch__thumb" />
            </span>
            {label && <span className="ui-switch__label">{label}</span>}
        </label>
    );
}
